import { Divider, Grid, List, ListItem, Typography } from '@mui/material';
import React from 'react';
import { getRatingFieldLabelByKey } from '../../../Types/Talent'; // Adjust the import path based on your project structure

interface ScoreListProps {
  scores: Record<string, number>; // The scores object (category and score pairs)
}

export const ScoreList: React.FC<ScoreListProps> = ({ scores }) => {
  const entries = Object.entries(scores);

  return (
    <List>
      {entries.length > 0 ? (
        entries.map(([category, averageScore], index) => (
          <React.Fragment key={category}>
            {index > 0 && <Divider variant="middle" />}
            <ListItem>
              <Grid container>
                <Grid item md={11} xs={11}>
                  <Typography variant="lora-body-medium">
                    {getRatingFieldLabelByKey(category)}
                  </Typography>
                </Grid>
                <Grid item md={1} xs={1}>
                  <Typography variant="lora-body-medium">
                    {averageScore}
                  </Typography>
                </Grid>
              </Grid>
            </ListItem>
          </React.Fragment>
        ))
      ) : (
        <Grid>
          <Typography variant="lora-body-medium">
            No scores available
          </Typography>
        </Grid>
      )}
    </List>
  );
};
